
import { refreshToken, logout } from "./auth";

const BASE_URL = process.env.REACT_APP_API_URL || "";

export const fetchWithAuth = async (url, options = {}) => {
  let token = localStorage.getItem("token");

  if (!token) {
    const refreshed = await refreshToken();
    if (!refreshed) {
      logout();
      throw new Error("Не удалось обновить токен");
    }
    token = localStorage.getItem("token");
  }

  const response = await fetch(`${BASE_URL}${url}`, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status === 401) {
    const refreshed = await refreshToken();
    if (!refreshed) {
      logout();
      throw new Error("Сессия истекла. Пожалуйста, войдите снова.");
    }
    
    token = localStorage.getItem("token");
    return fetch(`${BASE_URL}${url}`, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return response;
};
